import type {Address} from "viem";

/**
 * Smelt contract address. Baked in as a fallback so the hosted site works with no
 * env config (per the build prompt). Overridable via VITE_SMELT_CONTRACT.
 *
 * Replace the fallback below with the real deployed address after running
 * script/DeploySmelt.s.sol on Ritual testnet.
 */
export const SMELT_CONTRACT: Address =
  (import.meta.env.VITE_SMELT_CONTRACT as Address) ??
  "0xD96380bf67cc46f97D1dC06C0C7461C62F096e47";

/** System contract addresses on Ritual testnet (fixed, hardcoded). */
export const SYSTEM = {
  RITUAL_WALLET: "0x532F0dF0896F353d8C3DD8cc134e8129DA2a3948",
  SCHEDULER: "0x56e776BAE2DD60664b69Bd5F865F1180ffB7D58B",
  ASYNC_JOB_TRACKER: "0xC069FFCa0389f44eCA2C626e55491b0ab045AEF5",
  TEE_SERVICE_REGISTRY: "0x9644e8562cE0Fe12b4deeC4163c064A8862Bf47F",
  MODEL_PRICING_REGISTRY: "0x7A85F48b971ceBb75491b61abe279728F4c4384f",
} as const;

/** Precompile addresses (not deployed contracts — never use writeContract on these). */
export const PRECOMPILES = {
  HTTP_CALL: "0x0000000000000000000000000000000000000801",
  LLM: "0x0000000000000000000000000000000000000802",
} as const;

/** TEEServiceRegistry capability enum values. */
export const CAPABILITY = {
  HTTP_CALL: 0,
  LLM: 1,
} as const;

export const WALLETCONNECT_PROJECT_ID =
  import.meta.env.VITE_WC_PROJECT_ID ?? "get-a-project-id-from-cloud.walletconnect.com";
